import {useAttendeeVariables} from 'Event'
import {useTownhallTemplate, useTownhallUpdate} from 'Event/template/Townhall'
import ColorPicker from 'lib/ui/ColorPicker'
import Title from 'lib/ui/ConfigPanel/Title'
import Slider from 'lib/ui/Slider'
import TextField from 'lib/ui/TextField'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import React from 'react'
import {Controller} from 'react-hook-form'
import {useAddTranslation} from 'Event/LanguageProvider'

export default function TitleConfig() {
  const save = useTownhallUpdate()
  const {login} = useTownhallTemplate()

  const {
    form: {register},
  } = useConfig()

  const v = useAttendeeVariables()
  const addTranslation = useAddTranslation()

  const handleSave = (data: any) => {
    save({
      login: {
        welcome: {
          ...data.login.welcome,
          text: '{{login_welcome_text}}',
        },
      },
      localization: addTranslation({
        login_welcome_text: data.login.welcome.text ?? '',
      }),
    })
  }
  return (
    <Config title="Title" onSave={handleSave}>
      <SettingsPanel>
        <Title>Title</Title>
        <TextField
          name="login.welcome.text"
          defaultValue={v(login.welcome.text)}
          label="Text"
          fullWidth
          inputProps={{
            'aria-label': 'welcome text',
            ref: register,
          }}
        />
      </SettingsPanel>
      <StylingPanel>
        <StyleFields />
      </StylingPanel>
    </Config>
  )
}

export function StyleFields() {
  const {login, textColor} = useTownhallTemplate()
  const titleColor = login.welcome.color ? login.welcome.color : textColor

  const {
    form: {control},
  } = useConfig()

  return (
    <>
      <Controller
        name="login.welcome.color"
        defaultValue={titleColor}
        control={control}
        render={({value, onChange}) => (
          <ColorPicker
            label="Color"
            color={value}
            onPick={onChange}
            aria-label="welcome text color"
          />
        )}
      />
      <Controller
        name="login.welcome.fontSize"
        defaultValue={login.welcome.fontSize}
        control={control}
        render={({value, onChange}) => (
          <Slider
            valueLabelDisplay="auto"
            aria-label="welcome font size"
            value={value}
            onChange={onChange}
            step={1}
            min={5}
            max={50}
            label="Font Size"
          />
        )}
      />
    </>
  )
}
